import { useMemo } from "react";
import { useIntl } from "react-intl";
import messages from "./conflictAlertMessages";

const useConflictAlertTranslations = () => {
  const { formatMessage } = useIntl();

  const translations = useMemo(() => {
    return {
      title: formatMessage(messages.title),
      description: formatMessage(messages.description),
      warningText: formatMessage(messages.warningText),
      conflictItem: (
        firstName: string,
        lastName: string,
        date: string,
        time: string,
      ) =>
        formatMessage(messages.conflictItem, {
          firstName,
          lastName,
          date,
          time,
        }),
      btnEdit: formatMessage(messages.btnEdit),
      btnSave: formatMessage(messages.btnSave),
    };
  }, [formatMessage]);

  return translations;
};

export default useConflictAlertTranslations;
